import { BasicCommand } from "./BasicCommand";


import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";

/**
 * S2C_CASH_HASH
 * */
// TODO: Can be deleted? There's a newer class NCHCommand
export class GCHCommand extends BasicCommand {
    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_CASH_HASH;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            params.shift();
            BasicController.getInstance().paymentHash = String(params.shift());
            return true;
        }
        return false;
    }
}

